import { useEffect, useState, useMemo } from 'react';
import MarioCharacter from '../../../assets/img/mario.png';
import './LoadingScreen.css';
import { setLoadingScreen } from '../../../config/redux/engineSlice';
import { useDispatch } from 'react-redux';
import { useEmbarky, useAccount } from '@embarky/react';
import { darConfig } from '../../../config/embarky';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';


function getParams(data) {
  let params = new URLSearchParams(document.location.search);
  let target = params.get(data);
  return target;
}

const LoadingScreen = () => {
  const [isReady, setIsReady] = useState(false);
  const [token, setToken] = useState('');
  const { login, logout, authenticated, userAccount } = useEmbarky();
  const { isConnected } = useAccount();
  const location = useLocation();

  const dispatch = useDispatch();

  const activeAddress = useMemo(() => {
    if (!userAccount || !userAccount?.wallets) return '';
    for (let i = 0; i < userAccount?.wallets?.length; i++) {
      if (userAccount?.wallets[i]?.is_active) {
        return userAccount?.wallets[i]?.wallet_address;
      }
    }
  }, [userAccount]);

  const getAccessToken = async () => {
    try {
      const code = getParams('code');
      console.log('code =', code);
      const details = {
        client_id: darConfig.clientId,
        client_secret: darConfig.clientSecret,
        grant_type: 'authorization_code',
        code,
        redirect_uri: 'https://game-mario-interface.pages.dev/',
      };

      let formBody = [];
      for (let property in details) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + '=' + encodedValue);
      }
      formBody = formBody.join('&');

      const response = await fetch(`${darConfig.authUrl}/oauth2/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody,
      });
      const data = await response.json();
      console.log('data =', data);
      if (data.access_token) {
        setToken(data?.access_token);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const clickLogin = async () => {
    window.open(
      'https://dar-portal-interface-git-preview-impa.vercel.app/login' +
        '?client_id=' +
        darConfig.clientId +
        '&redirect_uri=' +
        'https://game-mario-interface.pages.dev/' +
        '&state=test&scope=Read',
      '_self'
    );
  };

  useEffect(() => {
    setTimeout(() => {
      setIsReady(true);
    }, 5000);
    if (!token && document.location.search.includes('code')) {
      getAccessToken();
    }
  }, [document.location.search, token]);

  return (
    <div className="loading-screen-container">
      <img src={MarioCharacter} alt="" className="loading-mario" />
      {!isReady && <h1 className="loading-title">Loading...</h1>}
      {isReady && token && (
        <div className="container">
          <button
            className="enter-button"
            onClick={() => dispatch(setLoadingScreen(false))}
          >
            ENTER
          </button>
          <h1>
            Welcome to the game!
          </h1>
        </div>
      )}
      {/* {isReady && (!authenticated || !userAccount || !isConnected) && (
        <button className="enter-button" onClick={() => login()}>
          1.LOGIN EMBARKY
        </button>
      )} */}
      {isReady && !token && (
        <button className="enter-button" onClick={() => clickLogin()}>
          LOGIN DAR ID
        </button>
      )}
    </div>
  );
};
export default LoadingScreen;
